import * as api from './constants'
const store = require('store')
// TODO:
// Make interceptor request for any request with `withCredentials: true` config

export function login (email, password) {
  return axios
    .post(api.LOGIN_URL, { 'session': { email, password } }, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(error)
    })
}

export function referral (ref) {
  return axios
    .get(api.REFERRAL_URL, {params: {ref}})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      if (error.response) {
        let obj = new Error(error.response.data.error)
        obj.status = error.response.status
        return Promise.reject(obj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function resendVerificationEmail (email) {
  return axios
    .post(api.RESEND_VERIFICATION_EMAIL_URL, {email})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      if (error.response) {
        // The request was made, but the server responded with a status code
        // that falls out of the range of 2xx
        let eobj = new Error(error.response.data.message)
        eobj.status = error.response.data.status
        return Promise.reject(eobj)
      } else {
        // Something happened in setting up the request that triggered an Error
        return Promise.reject(new Error(error.message))
      }
    })
}

export function outlets () {
  if (!loggedIn()) return Promise.reject(new Error('Not logged in'))

  return axios
    .get(api.OUTLETS_URL, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}

function resetLoggedIn () {
  Cookies.remove('remember_token', { path: '/', domain: '.mokapos.com' })
  store.clearAll()
}

export function loggedIn () {
  const loggedInData = store.get('response:login')
  const cookiesData = Cookies.get('remember_token')

  if (isLocalStorageNameSupported()) {
    if (!loggedInData || !cookiesData) {
      resetLoggedIn()
      return false
    }

    try {
      JSON.parse(loggedInData).user
      return true
    } catch (e) {
      resetLoggedIn()
      return false
    }
  } else {
    if (!cookiesData) {
      resetLoggedIn()
      return false
    } else {
      return true
    }
  }
}

export function logout () {
  if (!loggedIn()) {
    return Promise.resolve(false)
  }

  const successLogout = () => {
    resetLoggedIn()
    return Promise.resolve(true)
  }

  return axios
    .delete(api.LOGOUT_URL, { withCredentials: true })
    .then(response => {
      return successLogout()
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function registered (email) {
  return axios
    .get(api.REGISTER_URL + email, {email}, {withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function registerBusiness (data) {
  return axios
    .post(api.REGISTER_BUSINESS_URL, data)
    .then(response => {
      return Promise.resolve(response)
    })
}

export function getBusinessTypes () {
  return axios
    .get(api.BUSINESS_TYPES_URL)
    .then(response => {
      return Promise.resolve(response)
    })
}

export function selectOutlet (outletIds) {
  return axios
    .patch(api.UPDATE_SELECTED_OUTLET, {id: outletIds}, { withCredentials: true })
    .then(response => {
      return Promise.resolve(true)
    })
    .catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}

export function getProfile () {
  return axios
    .get(api.GET_PROFILE, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}

export function getBusinessCategories (businessTypeId) {
  return axios
    .get(api.BUSINESS_CATEGORIES_URL, {
      params: {
        business_type_id: businessTypeId
      }
    })
    .then(response => {
      return Promise.resolve(response)
    })
}
export function getResetPassword (query) {
  return axios
  .get(api.GET_RESET_PASSWORD_URL, {
    params: query,
    withCredentials: true
  })
  .then(response => {
    return Promise.resolve(response)
  })
  .catch(error => {
    const {response} = error
    return Promise.reject(response)
  })
}
export function resetPassword (query) {
  return axios
    .post(api.RESET_PASSWORD_URL, {access_token: query.access_token, password: query.newPassword, password_confirmation: query.confPassword}, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}

export function loadPrepareEncryption () {
  return axios
  .get(api.LOAD_PREPARE_ENCRYPTION_URL, {withCredentials: true})
  .then(response => {
    return Promise.resolve(response)
  })
  .catch(error => {
    const {response} = error
    return Promise.reject(response)
  })
}

function isLocalStorageNameSupported () {
  let testKey = 'test'
  let storage = window.localStorage
  try {
    storage.setItem(testKey, '1')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    return false
  }
}



// WEBPACK FOOTER //
// ./app/api/auth.js